// Complete list of all iPhone models ever released by Apple
// This is independent from the products catalog

export interface IPhoneModel {
  id: string;
  name: string;
  year: number;
  image?: string;
  specs: {
    display_size: string;
    display_technology: string;
    display_resolution: string;
    display_brightness?: string;
    display_refresh_rate: string;
    chip_model: string;
    chip_cores?: string;
    chip_gpu?: string;
    camera_main: string;
    camera_ultrawide?: string;
    camera_telephoto?: string;
    camera_zoom?: string;
    camera_video: string;
    battery_video_playback?: string;
    battery_charging?: string;
    weight: string;
    dimensions: string;
    water_resistance?: string;
    face_id: boolean;
    touch_id: boolean;
    connectivity_5g: boolean;
  };
}

export const allIPhoneModels: IPhoneModel[] = [
  // 2025 - iPhone 17 Series (Expected)
  {
    id: "iphone-17-pro-max",
    name: "iPhone 17 Pro Max",
    year: 2025,
    image: "__iphone17_pro_max__",
    specs: {
      display_size: "6.9\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2868 x 1320",
      display_brightness: "2500 nits",
      display_refresh_rate: "1-120Hz ProMotion",
      chip_model: "A19 Pro",
      chip_cores: "8-core CPU",
      chip_gpu: "6-core GPU",
      camera_main: "48 MP",
      camera_ultrawide: "48 MP",
      camera_telephoto: "48 MP",
      camera_zoom: "5x ottico",
      camera_video: "8K 30fps",
      battery_video_playback: "35 ore",
      battery_charging: "MagSafe 30W",
      weight: "225 g",
      dimensions: "163 x 77.5 x 8.1 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  {
    id: "iphone-17-pro",
    name: "iPhone 17 Pro",
    year: 2025,
    image: "__iphone17_pro__",
    specs: {
      display_size: "6.3\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2622 x 1206",
      display_brightness: "2500 nits",
      display_refresh_rate: "1-120Hz ProMotion",
      chip_model: "A19 Pro",
      chip_cores: "8-core CPU",
      chip_gpu: "6-core GPU",
      camera_main: "48 MP",
      camera_ultrawide: "48 MP",
      camera_telephoto: "48 MP",
      camera_zoom: "5x ottico",
      camera_video: "8K 30fps",
      battery_video_playback: "29 ore",
      battery_charging: "MagSafe 30W",
      weight: "195 g",
      dimensions: "149.5 x 71.3 x 8.1 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  {
    id: "iphone-17-plus",
    name: "iPhone 17 Plus",
    year: 2025,
    image: "__iphone17_standard__",
    specs: {
      display_size: "6.7\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2796 x 1290",
      display_brightness: "2200 nits",
      display_refresh_rate: "1-120Hz ProMotion",
      chip_model: "A19",
      chip_cores: "6-core CPU",
      chip_gpu: "5-core GPU",
      camera_main: "48 MP",
      camera_ultrawide: "12 MP",
      camera_video: "4K Dolby Vision 120fps",
      battery_video_playback: "28 ore",
      battery_charging: "MagSafe 25W",
      weight: "197 g",
      dimensions: "160.8 x 77.6 x 7.75 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  {
    id: "iphone-17",
    name: "iPhone 17",
    year: 2025,
    image: "__iphone17_standard__",
    specs: {
      display_size: "6.1\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2556 x 1179",
      display_brightness: "2200 nits",
      display_refresh_rate: "1-120Hz ProMotion",
      chip_model: "A19",
      chip_cores: "6-core CPU",
      chip_gpu: "5-core GPU",
      camera_main: "48 MP",
      camera_ultrawide: "12 MP",
      camera_video: "4K Dolby Vision 120fps",
      battery_video_playback: "24 ore",
      battery_charging: "MagSafe 25W",
      weight: "168 g",
      dimensions: "147.5 x 71.5 x 7.75 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  {
    id: "iphone-17-air",
    name: "iPhone 17 Air",
    year: 2025,
    image: "__iphone17_air__",
    specs: {
      display_size: "6.6\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2740 x 1260",
      display_brightness: "2200 nits",
      display_refresh_rate: "1-120Hz ProMotion",
      chip_model: "A19",
      chip_cores: "8-core CPU",
      chip_gpu: "5-core GPU",
      camera_main: "48 MP",
      camera_video: "4K Dolby Vision 60fps",
      battery_video_playback: "18 ore",
      battery_charging: "MagSafe 25W",
      weight: "145 g",
      dimensions: "155 x 70 x 5.5 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  // 2024 - iPhone 16 Series
  {
    id: "iphone-16-pro-max",
    name: "iPhone 16 Pro Max",
    year: 2024,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-16-pro-max.jpg",
    specs: {
      display_size: "6.9\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2868 x 1320",
      display_brightness: "2000 nits",
      display_refresh_rate: "1-120Hz ProMotion",
      chip_model: "A18 Pro",
      chip_cores: "6-core CPU",
      chip_gpu: "6-core GPU",
      camera_main: "48 MP",
      camera_ultrawide: "48 MP",
      camera_telephoto: "12 MP",
      camera_zoom: "5x ottico",
      camera_video: "4K Dolby Vision 120fps",
      battery_video_playback: "33 ore",
      battery_charging: "MagSafe 25W",
      weight: "227 g",
      dimensions: "163 x 77.6 x 8.25 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  {
    id: "iphone-16-pro",
    name: "iPhone 16 Pro",
    year: 2024,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-16-pro.jpg",
    specs: {
      display_size: "6.3\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2622 x 1206",
      display_brightness: "2000 nits",
      display_refresh_rate: "1-120Hz ProMotion",
      chip_model: "A18 Pro",
      chip_cores: "6-core CPU",
      chip_gpu: "6-core GPU",
      camera_main: "48 MP",
      camera_ultrawide: "48 MP",
      camera_telephoto: "12 MP",
      camera_zoom: "5x ottico",
      camera_video: "4K Dolby Vision 120fps",
      battery_video_playback: "27 ore",
      battery_charging: "MagSafe 25W",
      weight: "199 g",
      dimensions: "149.6 x 71.5 x 8.25 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  {
    id: "iphone-16-plus",
    name: "iPhone 16 Plus",
    year: 2024,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-16-plus.jpg",
    specs: {
      display_size: "6.7\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2796 x 1290",
      display_brightness: "2000 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A18",
      chip_cores: "6-core CPU",
      chip_gpu: "5-core GPU",
      camera_main: "48 MP",
      camera_ultrawide: "12 MP",
      camera_video: "4K Dolby Vision 60fps",
      battery_video_playback: "27 ore",
      battery_charging: "MagSafe 25W",
      weight: "199 g",
      dimensions: "160.9 x 77.8 x 7.80 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  {
    id: "iphone-16",
    name: "iPhone 16",
    year: 2024,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-16.jpg",
    specs: {
      display_size: "6.1\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2556 x 1179",
      display_brightness: "2000 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A18",
      chip_cores: "6-core CPU",
      chip_gpu: "5-core GPU",
      camera_main: "48 MP",
      camera_ultrawide: "12 MP",
      camera_video: "4K Dolby Vision 60fps",
      battery_video_playback: "22 ore",
      battery_charging: "MagSafe 25W",
      weight: "170 g",
      dimensions: "147.6 x 71.6 x 7.80 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  // 2023 - iPhone 15 Series
  {
    id: "iphone-15-pro-max",
    name: "iPhone 15 Pro Max",
    year: 2023,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-15-pro-max.jpg",
    specs: {
      display_size: "6.7\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2796 x 1290",
      display_brightness: "2000 nits",
      display_refresh_rate: "1-120Hz ProMotion",
      chip_model: "A17 Pro",
      chip_cores: "6-core CPU",
      chip_gpu: "6-core GPU",
      camera_main: "48 MP",
      camera_ultrawide: "12 MP",
      camera_telephoto: "12 MP",
      camera_zoom: "5x ottico",
      camera_video: "4K ProRes 60fps",
      battery_video_playback: "29 ore",
      battery_charging: "MagSafe 15W",
      weight: "221 g",
      dimensions: "159.9 x 76.7 x 8.25 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  {
    id: "iphone-15-pro",
    name: "iPhone 15 Pro",
    year: 2023,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-15-pro.jpg",
    specs: {
      display_size: "6.1\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2556 x 1179",
      display_brightness: "2000 nits",
      display_refresh_rate: "1-120Hz ProMotion",
      chip_model: "A17 Pro",
      chip_cores: "6-core CPU",
      chip_gpu: "6-core GPU",
      camera_main: "48 MP",
      camera_ultrawide: "12 MP",
      camera_telephoto: "12 MP",
      camera_zoom: "3x ottico",
      camera_video: "4K ProRes 60fps",
      battery_video_playback: "23 ore",
      battery_charging: "MagSafe 15W",
      weight: "187 g",
      dimensions: "146.6 x 70.6 x 8.25 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  {
    id: "iphone-15-plus",
    name: "iPhone 15 Plus",
    year: 2023,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-15-plus.jpg",
    specs: {
      display_size: "6.7\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2796 x 1290",
      display_brightness: "2000 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A16 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "5-core GPU",
      camera_main: "48 MP",
      camera_ultrawide: "12 MP",
      camera_video: "4K Dolby Vision 60fps",
      battery_video_playback: "26 ore",
      battery_charging: "MagSafe 15W",
      weight: "201 g",
      dimensions: "160.9 x 77.8 x 7.80 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  {
    id: "iphone-15",
    name: "iPhone 15",
    year: 2023,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-15.jpg",
    specs: {
      display_size: "6.1\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2556 x 1179",
      display_brightness: "2000 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A16 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "5-core GPU",
      camera_main: "48 MP",
      camera_ultrawide: "12 MP",
      camera_video: "4K Dolby Vision 60fps",
      battery_video_playback: "20 ore",
      battery_charging: "MagSafe 15W",
      weight: "171 g",
      dimensions: "147.6 x 71.6 x 7.80 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  // 2022 - iPhone 14 Series
  {
    id: "iphone-14-pro-max",
    name: "iPhone 14 Pro Max",
    year: 2022,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-14-pro-max.jpg",
    specs: {
      display_size: "6.7\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2796 x 1290",
      display_brightness: "2000 nits",
      display_refresh_rate: "1-120Hz ProMotion",
      chip_model: "A16 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "5-core GPU",
      camera_main: "48 MP",
      camera_ultrawide: "12 MP",
      camera_telephoto: "12 MP",
      camera_zoom: "3x ottico",
      camera_video: "4K ProRes 30fps",
      battery_video_playback: "29 ore",
      battery_charging: "MagSafe 15W",
      weight: "240 g",
      dimensions: "160.7 x 77.6 x 7.85 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  {
    id: "iphone-14-pro",
    name: "iPhone 14 Pro",
    year: 2022,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-14-pro.jpg",
    specs: {
      display_size: "6.1\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2556 x 1179",
      display_brightness: "2000 nits",
      display_refresh_rate: "1-120Hz ProMotion",
      chip_model: "A16 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "5-core GPU",
      camera_main: "48 MP",
      camera_ultrawide: "12 MP",
      camera_telephoto: "12 MP",
      camera_zoom: "3x ottico",
      camera_video: "4K ProRes 30fps",
      battery_video_playback: "23 ore",
      battery_charging: "MagSafe 15W",
      weight: "206 g",
      dimensions: "147.5 x 71.5 x 7.85 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  {
    id: "iphone-14-plus",
    name: "iPhone 14 Plus",
    year: 2022,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-14-plus.jpg",
    specs: {
      display_size: "6.7\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2778 x 1284",
      display_brightness: "1200 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A15 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "5-core GPU",
      camera_main: "12 MP",
      camera_ultrawide: "12 MP",
      camera_video: "4K Dolby Vision 60fps",
      battery_video_playback: "26 ore",
      battery_charging: "MagSafe 15W",
      weight: "203 g",
      dimensions: "160.8 x 78.1 x 7.80 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  {
    id: "iphone-14",
    name: "iPhone 14",
    year: 2022,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-14.jpg",
    specs: {
      display_size: "6.1\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2532 x 1170",
      display_brightness: "1200 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A15 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "5-core GPU",
      camera_main: "12 MP",
      camera_ultrawide: "12 MP",
      camera_video: "4K Dolby Vision 60fps",
      battery_video_playback: "20 ore",
      battery_charging: "MagSafe 15W",
      weight: "172 g",
      dimensions: "146.7 x 71.5 x 7.80 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  // 2022 - iPhone SE 3rd Gen
  {
    id: "iphone-se-3",
    name: "iPhone SE (3ª gen)",
    year: 2022,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-se-2022.jpg",
    specs: {
      display_size: "4.7\"",
      display_technology: "Retina HD LCD",
      display_resolution: "1334 x 750",
      display_brightness: "625 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A15 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "4-core GPU",
      camera_main: "12 MP",
      camera_video: "4K 60fps",
      battery_video_playback: "15 ore",
      battery_charging: "20W cablata",
      weight: "144 g",
      dimensions: "138.4 x 67.3 x 7.30 mm",
      water_resistance: "IP67",
      face_id: false,
      touch_id: true,
      connectivity_5g: true,
    },
  },
  // 2021 - iPhone 13 Series
  {
    id: "iphone-13-pro-max",
    name: "iPhone 13 Pro Max",
    year: 2021,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-13-pro-max.jpg",
    specs: {
      display_size: "6.7\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2778 x 1284",
      display_brightness: "1000 nits",
      display_refresh_rate: "10-120Hz ProMotion",
      chip_model: "A15 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "5-core GPU",
      camera_main: "12 MP",
      camera_ultrawide: "12 MP",
      camera_telephoto: "12 MP",
      camera_zoom: "3x ottico",
      camera_video: "4K ProRes 30fps",
      battery_video_playback: "28 ore",
      battery_charging: "MagSafe 15W",
      weight: "238 g",
      dimensions: "160.8 x 78.1 x 7.65 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  {
    id: "iphone-13-pro",
    name: "iPhone 13 Pro",
    year: 2021,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-13-pro.jpg",
    specs: {
      display_size: "6.1\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2532 x 1170",
      display_brightness: "1000 nits",
      display_refresh_rate: "10-120Hz ProMotion",
      chip_model: "A15 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "5-core GPU",
      camera_main: "12 MP",
      camera_ultrawide: "12 MP",
      camera_telephoto: "12 MP",
      camera_zoom: "3x ottico",
      camera_video: "4K ProRes 30fps",
      battery_video_playback: "22 ore",
      battery_charging: "MagSafe 15W",
      weight: "203 g",
      dimensions: "146.7 x 71.5 x 7.65 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  {
    id: "iphone-13",
    name: "iPhone 13",
    year: 2021,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-13.jpg",
    specs: {
      display_size: "6.1\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2532 x 1170",
      display_brightness: "800 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A15 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "4-core GPU",
      camera_main: "12 MP",
      camera_ultrawide: "12 MP",
      camera_video: "4K Dolby Vision 60fps",
      battery_video_playback: "19 ore",
      battery_charging: "MagSafe 15W",
      weight: "173 g",
      dimensions: "146.7 x 71.5 x 7.65 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  {
    id: "iphone-13-mini",
    name: "iPhone 13 mini",
    year: 2021,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-13-mini.jpg",
    specs: {
      display_size: "5.4\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2340 x 1080",
      display_brightness: "800 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A15 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "4-core GPU",
      camera_main: "12 MP",
      camera_ultrawide: "12 MP",
      camera_video: "4K Dolby Vision 60fps",
      battery_video_playback: "17 ore",
      battery_charging: "MagSafe 12W",
      weight: "140 g",
      dimensions: "131.5 x 64.2 x 7.65 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  // 2020 - iPhone 12 Series
  {
    id: "iphone-12-pro-max",
    name: "iPhone 12 Pro Max",
    year: 2020,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-12-pro-max-.jpg",
    specs: {
      display_size: "6.7\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2778 x 1284",
      display_brightness: "800 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A14 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "4-core GPU",
      camera_main: "12 MP",
      camera_ultrawide: "12 MP",
      camera_telephoto: "12 MP",
      camera_zoom: "2.5x ottico",
      camera_video: "4K Dolby Vision 60fps",
      battery_video_playback: "20 ore",
      battery_charging: "MagSafe 15W",
      weight: "226 g",
      dimensions: "160.8 x 78.1 x 7.40 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  {
    id: "iphone-12-pro",
    name: "iPhone 12 Pro",
    year: 2020,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-12-pro.jpg",
    specs: {
      display_size: "6.1\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2532 x 1170",
      display_brightness: "800 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A14 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "4-core GPU",
      camera_main: "12 MP",
      camera_ultrawide: "12 MP",
      camera_telephoto: "12 MP",
      camera_zoom: "2x ottico",
      camera_video: "4K Dolby Vision 60fps",
      battery_video_playback: "17 ore",
      battery_charging: "MagSafe 15W",
      weight: "187 g",
      dimensions: "146.7 x 71.5 x 7.40 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  {
    id: "iphone-12",
    name: "iPhone 12",
    year: 2020,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-12.jpg",
    specs: {
      display_size: "6.1\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2532 x 1170",
      display_brightness: "625 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A14 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "4-core GPU",
      camera_main: "12 MP",
      camera_ultrawide: "12 MP",
      camera_video: "4K Dolby Vision 60fps",
      battery_video_playback: "17 ore",
      battery_charging: "MagSafe 15W",
      weight: "162 g",
      dimensions: "146.7 x 71.5 x 7.40 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  {
    id: "iphone-12-mini",
    name: "iPhone 12 mini",
    year: 2020,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-12-mini.jpg",
    specs: {
      display_size: "5.4\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2340 x 1080",
      display_brightness: "625 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A14 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "4-core GPU",
      camera_main: "12 MP",
      camera_ultrawide: "12 MP",
      camera_video: "4K Dolby Vision 60fps",
      battery_video_playback: "15 ore",
      battery_charging: "MagSafe 12W",
      weight: "133 g",
      dimensions: "131.5 x 64.2 x 7.40 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: true,
    },
  },
  // 2020 - iPhone SE 2nd Gen
  {
    id: "iphone-se-2",
    name: "iPhone SE (2ª gen)",
    year: 2020,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-se-2020.jpg",
    specs: {
      display_size: "4.7\"",
      display_technology: "Retina HD LCD",
      display_resolution: "1334 x 750",
      display_brightness: "625 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A13 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "4-core GPU",
      camera_main: "12 MP",
      camera_video: "4K 60fps",
      battery_video_playback: "13 ore",
      battery_charging: "18W cablata",
      weight: "148 g",
      dimensions: "138.4 x 67.3 x 7.30 mm",
      water_resistance: "IP67",
      face_id: false,
      touch_id: true,
      connectivity_5g: false,
    },
  },
  // 2019 - iPhone 11 Series
  {
    id: "iphone-11-pro-max",
    name: "iPhone 11 Pro Max",
    year: 2019,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-11-pro-max.jpg",
    specs: {
      display_size: "6.5\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2688 x 1242",
      display_brightness: "800 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A13 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "4-core GPU",
      camera_main: "12 MP",
      camera_ultrawide: "12 MP",
      camera_telephoto: "12 MP",
      camera_zoom: "2x ottico",
      camera_video: "4K 60fps",
      battery_video_playback: "20 ore",
      battery_charging: "18W cablata",
      weight: "226 g",
      dimensions: "158.0 x 77.8 x 8.10 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: false,
    },
  },
  {
    id: "iphone-11-pro",
    name: "iPhone 11 Pro",
    year: 2019,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-11-pro.jpg",
    specs: {
      display_size: "5.8\"",
      display_technology: "Super Retina XDR OLED",
      display_resolution: "2436 x 1125",
      display_brightness: "800 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A13 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "4-core GPU",
      camera_main: "12 MP",
      camera_ultrawide: "12 MP",
      camera_telephoto: "12 MP",
      camera_zoom: "2x ottico",
      camera_video: "4K 60fps",
      battery_video_playback: "18 ore",
      battery_charging: "18W cablata",
      weight: "188 g",
      dimensions: "144.0 x 71.4 x 8.10 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: false,
    },
  },
  {
    id: "iphone-11",
    name: "iPhone 11",
    year: 2019,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-11.jpg",
    specs: {
      display_size: "6.1\"",
      display_technology: "Liquid Retina LCD",
      display_resolution: "1792 x 828",
      display_brightness: "625 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A13 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "4-core GPU",
      camera_main: "12 MP",
      camera_ultrawide: "12 MP",
      camera_video: "4K 60fps",
      battery_video_playback: "17 ore",
      battery_charging: "18W cablata",
      weight: "194 g",
      dimensions: "150.9 x 75.7 x 8.30 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: false,
    },
  },
  // 2018 - iPhone XS/XR Series
  {
    id: "iphone-xs-max",
    name: "iPhone XS Max",
    year: 2018,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-xs-max-new.jpg",
    specs: {
      display_size: "6.5\"",
      display_technology: "Super Retina OLED",
      display_resolution: "2688 x 1242",
      display_brightness: "625 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A12 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "4-core GPU",
      camera_main: "12 MP",
      camera_telephoto: "12 MP",
      camera_zoom: "2x ottico",
      camera_video: "4K 60fps",
      battery_video_playback: "15 ore",
      battery_charging: "15W cablata",
      weight: "208 g",
      dimensions: "157.5 x 77.4 x 7.70 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: false,
    },
  },
  {
    id: "iphone-xs",
    name: "iPhone XS",
    year: 2018,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-xs-new.jpg",
    specs: {
      display_size: "5.8\"",
      display_technology: "Super Retina OLED",
      display_resolution: "2436 x 1125",
      display_brightness: "625 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A12 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "4-core GPU",
      camera_main: "12 MP",
      camera_telephoto: "12 MP",
      camera_zoom: "2x ottico",
      camera_video: "4K 60fps",
      battery_video_playback: "14 ore",
      battery_charging: "15W cablata",
      weight: "177 g",
      dimensions: "143.6 x 70.9 x 7.70 mm",
      water_resistance: "IP68",
      face_id: true,
      touch_id: false,
      connectivity_5g: false,
    },
  },
  {
    id: "iphone-xr",
    name: "iPhone XR",
    year: 2018,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-xr-new.jpg",
    specs: {
      display_size: "6.1\"",
      display_technology: "Liquid Retina LCD",
      display_resolution: "1792 x 828",
      display_brightness: "625 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A12 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "4-core GPU",
      camera_main: "12 MP",
      camera_video: "4K 60fps",
      battery_video_playback: "16 ore",
      battery_charging: "15W cablata",
      weight: "194 g",
      dimensions: "150.9 x 75.7 x 8.30 mm",
      water_resistance: "IP67",
      face_id: true,
      touch_id: false,
      connectivity_5g: false,
    },
  },
  // 2017 - iPhone X/8 Series
  {
    id: "iphone-x",
    name: "iPhone X",
    year: 2017,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-x.jpg",
    specs: {
      display_size: "5.8\"",
      display_technology: "Super Retina OLED",
      display_resolution: "2436 x 1125",
      display_brightness: "625 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A11 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "3-core GPU",
      camera_main: "12 MP",
      camera_telephoto: "12 MP",
      camera_zoom: "2x ottico",
      camera_video: "4K 60fps",
      battery_video_playback: "13 ore",
      battery_charging: "15W cablata",
      weight: "174 g",
      dimensions: "143.6 x 70.9 x 7.70 mm",
      water_resistance: "IP67",
      face_id: true,
      touch_id: false,
      connectivity_5g: false,
    },
  },
  {
    id: "iphone-8-plus",
    name: "iPhone 8 Plus",
    year: 2017,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-8-plus-2.jpg",
    specs: {
      display_size: "5.5\"",
      display_technology: "Retina HD LCD",
      display_resolution: "1920 x 1080",
      display_brightness: "625 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A11 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "3-core GPU",
      camera_main: "12 MP",
      camera_telephoto: "12 MP",
      camera_zoom: "2x ottico",
      camera_video: "4K 60fps",
      battery_video_playback: "14 ore",
      battery_charging: "15W cablata",
      weight: "202 g",
      dimensions: "158.4 x 78.1 x 7.50 mm",
      water_resistance: "IP67",
      face_id: false,
      touch_id: true,
      connectivity_5g: false,
    },
  },
  {
    id: "iphone-8",
    name: "iPhone 8",
    year: 2017,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-8-3.jpg",
    specs: {
      display_size: "4.7\"",
      display_technology: "Retina HD LCD",
      display_resolution: "1334 x 750",
      display_brightness: "625 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A11 Bionic",
      chip_cores: "6-core CPU",
      chip_gpu: "3-core GPU",
      camera_main: "12 MP",
      camera_video: "4K 60fps",
      battery_video_playback: "13 ore",
      battery_charging: "15W cablata",
      weight: "148 g",
      dimensions: "138.4 x 67.3 x 7.30 mm",
      water_resistance: "IP67",
      face_id: false,
      touch_id: true,
      connectivity_5g: false,
    },
  },
  // 2016 - iPhone 7 Series
  {
    id: "iphone-7-plus",
    name: "iPhone 7 Plus",
    year: 2016,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-7-plus2.jpg",
    specs: {
      display_size: "5.5\"",
      display_technology: "Retina HD LCD",
      display_resolution: "1920 x 1080",
      display_brightness: "625 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A10 Fusion",
      chip_cores: "4-core CPU",
      chip_gpu: "6-core GPU",
      camera_main: "12 MP",
      camera_telephoto: "12 MP",
      camera_zoom: "2x ottico",
      camera_video: "4K 30fps",
      battery_video_playback: "14 ore",
      battery_charging: "10W cablata",
      weight: "188 g",
      dimensions: "158.2 x 77.9 x 7.30 mm",
      water_resistance: "IP67",
      face_id: false,
      touch_id: true,
      connectivity_5g: false,
    },
  },
  {
    id: "iphone-7",
    name: "iPhone 7",
    year: 2016,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-7r4.jpg",
    specs: {
      display_size: "4.7\"",
      display_technology: "Retina HD LCD",
      display_resolution: "1334 x 750",
      display_brightness: "625 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A10 Fusion",
      chip_cores: "4-core CPU",
      chip_gpu: "6-core GPU",
      camera_main: "12 MP",
      camera_video: "4K 30fps",
      battery_video_playback: "13 ore",
      battery_charging: "10W cablata",
      weight: "138 g",
      dimensions: "138.3 x 67.1 x 7.10 mm",
      water_resistance: "IP67",
      face_id: false,
      touch_id: true,
      connectivity_5g: false,
    },
  },
  // 2016 - iPhone SE 1st Gen
  {
    id: "iphone-se-1",
    name: "iPhone SE (1ª gen)",
    year: 2016,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-se.jpg",
    specs: {
      display_size: "4.0\"",
      display_technology: "Retina LCD",
      display_resolution: "1136 x 640",
      display_brightness: "500 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A9",
      chip_cores: "2-core CPU",
      chip_gpu: "6-core GPU",
      camera_main: "12 MP",
      camera_video: "4K 30fps",
      battery_video_playback: "13 ore",
      battery_charging: "5W cablata",
      weight: "113 g",
      dimensions: "123.8 x 58.6 x 7.60 mm",
      face_id: false,
      touch_id: true,
      connectivity_5g: false,
    },
  },
  // 2015 - iPhone 6s Series
  {
    id: "iphone-6s-plus",
    name: "iPhone 6s Plus",
    year: 2015,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-6s-plus-3.jpg",
    specs: {
      display_size: "5.5\"",
      display_technology: "Retina HD LCD",
      display_resolution: "1920 x 1080",
      display_brightness: "500 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A9",
      chip_cores: "2-core CPU",
      chip_gpu: "6-core GPU",
      camera_main: "12 MP",
      camera_video: "4K 30fps",
      battery_video_playback: "14 ore",
      battery_charging: "5W cablata",
      weight: "192 g",
      dimensions: "158.2 x 77.9 x 7.30 mm",
      face_id: false,
      touch_id: true,
      connectivity_5g: false,
    },
  },
  {
    id: "iphone-6s",
    name: "iPhone 6s",
    year: 2015,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-6s2.jpg",
    specs: {
      display_size: "4.7\"",
      display_technology: "Retina HD LCD",
      display_resolution: "1334 x 750",
      display_brightness: "500 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A9",
      chip_cores: "2-core CPU",
      chip_gpu: "6-core GPU",
      camera_main: "12 MP",
      camera_video: "4K 30fps",
      battery_video_playback: "11 ore",
      battery_charging: "5W cablata",
      weight: "143 g",
      dimensions: "138.3 x 67.1 x 7.10 mm",
      face_id: false,
      touch_id: true,
      connectivity_5g: false,
    },
  },
  // 2014 - iPhone 6 Series
  {
    id: "iphone-6-plus",
    name: "iPhone 6 Plus",
    year: 2014,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-6-plus-2.jpg",
    specs: {
      display_size: "5.5\"",
      display_technology: "Retina HD LCD",
      display_resolution: "1920 x 1080",
      display_brightness: "500 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A8",
      chip_cores: "2-core CPU",
      chip_gpu: "4-core GPU",
      camera_main: "8 MP",
      camera_video: "1080p 60fps",
      battery_video_playback: "14 ore",
      battery_charging: "5W cablata",
      weight: "172 g",
      dimensions: "158.1 x 77.8 x 7.10 mm",
      face_id: false,
      touch_id: true,
      connectivity_5g: false,
    },
  },
  {
    id: "iphone-6",
    name: "iPhone 6",
    year: 2014,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-6-3.jpg",
    specs: {
      display_size: "4.7\"",
      display_technology: "Retina HD LCD",
      display_resolution: "1334 x 750",
      display_brightness: "500 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A8",
      chip_cores: "2-core CPU",
      chip_gpu: "4-core GPU",
      camera_main: "8 MP",
      camera_video: "1080p 60fps",
      battery_video_playback: "11 ore",
      battery_charging: "5W cablata",
      weight: "129 g",
      dimensions: "138.1 x 67.0 x 6.90 mm",
      face_id: false,
      touch_id: true,
      connectivity_5g: false,
    },
  },
  // 2013 - iPhone 5s/5c
  {
    id: "iphone-5s",
    name: "iPhone 5s",
    year: 2013,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-5s2.jpg",
    specs: {
      display_size: "4.0\"",
      display_technology: "Retina LCD",
      display_resolution: "1136 x 640",
      display_brightness: "500 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A7",
      chip_cores: "2-core CPU",
      chip_gpu: "4-core GPU",
      camera_main: "8 MP",
      camera_video: "1080p 30fps",
      battery_video_playback: "10 ore",
      battery_charging: "5W cablata",
      weight: "112 g",
      dimensions: "123.8 x 58.6 x 7.60 mm",
      face_id: false,
      touch_id: true,
      connectivity_5g: false,
    },
  },
  {
    id: "iphone-5c",
    name: "iPhone 5c",
    year: 2013,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-5c2.jpg",
    specs: {
      display_size: "4.0\"",
      display_technology: "Retina LCD",
      display_resolution: "1136 x 640",
      display_brightness: "500 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A6",
      chip_cores: "2-core CPU",
      chip_gpu: "3-core GPU",
      camera_main: "8 MP",
      camera_video: "1080p 30fps",
      battery_video_playback: "10 ore",
      battery_charging: "5W cablata",
      weight: "132 g",
      dimensions: "124.4 x 59.2 x 8.97 mm",
      face_id: false,
      touch_id: false,
      connectivity_5g: false,
    },
  },
  // 2012 - iPhone 5
  {
    id: "iphone-5",
    name: "iPhone 5",
    year: 2012,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-5-2.jpg",
    specs: {
      display_size: "4.0\"",
      display_technology: "Retina LCD",
      display_resolution: "1136 x 640",
      display_brightness: "500 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A6",
      chip_cores: "2-core CPU",
      chip_gpu: "3-core GPU",
      camera_main: "8 MP",
      camera_video: "1080p 30fps",
      battery_video_playback: "10 ore",
      battery_charging: "5W cablata",
      weight: "112 g",
      dimensions: "123.8 x 58.6 x 7.60 mm",
      face_id: false,
      touch_id: false,
      connectivity_5g: false,
    },
  },
  // 2011 - iPhone 4S
  {
    id: "iphone-4s",
    name: "iPhone 4S",
    year: 2011,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-4s-new.jpg",
    specs: {
      display_size: "3.5\"",
      display_technology: "Retina LCD",
      display_resolution: "960 x 640",
      display_brightness: "500 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A5",
      chip_cores: "2-core CPU",
      chip_gpu: "2-core GPU",
      camera_main: "8 MP",
      camera_video: "1080p 30fps",
      battery_video_playback: "10 ore",
      battery_charging: "5W cablata",
      weight: "140 g",
      dimensions: "115.2 x 58.6 x 9.30 mm",
      face_id: false,
      touch_id: false,
      connectivity_5g: false,
    },
  },
  // 2010 - iPhone 4
  {
    id: "iphone-4",
    name: "iPhone 4",
    year: 2010,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-4-1.jpg",
    specs: {
      display_size: "3.5\"",
      display_technology: "Retina LCD",
      display_resolution: "960 x 640",
      display_brightness: "500 nits",
      display_refresh_rate: "60Hz",
      chip_model: "A4",
      chip_cores: "1-core CPU",
      chip_gpu: "1-core GPU",
      camera_main: "5 MP",
      camera_video: "720p 30fps",
      battery_video_playback: "10 ore",
      battery_charging: "5W cablata",
      weight: "137 g",
      dimensions: "115.2 x 58.6 x 9.30 mm",
      face_id: false,
      touch_id: false,
      connectivity_5g: false,
    },
  },
  // 2009 - iPhone 3GS
  {
    id: "iphone-3gs",
    name: "iPhone 3GS",
    year: 2009,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-3gs.jpg",
    specs: {
      display_size: "3.5\"",
      display_technology: "LCD",
      display_resolution: "480 x 320",
      display_brightness: "500 nits",
      display_refresh_rate: "60Hz",
      chip_model: "Samsung APL0298C05",
      chip_cores: "1-core CPU",
      camera_main: "3 MP",
      camera_video: "VGA 30fps",
      battery_video_playback: "10 ore",
      battery_charging: "5W cablata",
      weight: "135 g",
      dimensions: "115.5 x 62.1 x 12.30 mm",
      face_id: false,
      touch_id: false,
      connectivity_5g: false,
    },
  },
  // 2008 - iPhone 3G
  {
    id: "iphone-3g",
    name: "iPhone 3G",
    year: 2008,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone-3g-1.jpg",
    specs: {
      display_size: "3.5\"",
      display_technology: "LCD",
      display_resolution: "480 x 320",
      display_brightness: "500 nits",
      display_refresh_rate: "60Hz",
      chip_model: "Samsung 32-bit RISC",
      chip_cores: "1-core CPU",
      camera_main: "2 MP",
      camera_video: "N/D",
      battery_video_playback: "7 ore",
      battery_charging: "5W cablata",
      weight: "133 g",
      dimensions: "115.5 x 62.1 x 12.30 mm",
      face_id: false,
      touch_id: false,
      connectivity_5g: false,
    },
  },
  // 2007 - Original iPhone
  {
    id: "iphone-original",
    name: "iPhone (1ª gen)",
    year: 2007,
    image: "https://fdn2.gsmarena.com/vv/bigpic/apple-iphone.jpg",
    specs: {
      display_size: "3.5\"",
      display_technology: "LCD",
      display_resolution: "480 x 320",
      display_brightness: "500 nits",
      display_refresh_rate: "60Hz",
      chip_model: "Samsung 32-bit RISC",
      chip_cores: "1-core CPU",
      camera_main: "2 MP",
      camera_video: "N/D",
      battery_video_playback: "7 ore",
      battery_charging: "5W cablata",
      weight: "135 g",
      dimensions: "115.0 x 61.0 x 11.60 mm",
      face_id: false,
      touch_id: false,
      connectivity_5g: false,
    },
  },
];

// Helper to get models by year
export const getModelsByYear = () => {
  const byYear: Record<number, IPhoneModel[]> = {};
  allIPhoneModels.forEach((model) => {
    if (!byYear[model.year]) byYear[model.year] = [];
    byYear[model.year].push(model);
  });
  return byYear;
};

// Get all years sorted descending
export const getAllYears = () => {
  return [...new Set(allIPhoneModels.map((m) => m.year))].sort((a, b) => b - a);
};
